import { frCH } from "../../../../date-fns/locale/fr-CH.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    frCH
  }
};